import React, {useState} from "react";
import axios from "axios";
import moment from "moment";
import {
    Form,
    Input,
    Header,
    Grid,
    Button,
    Table,
    Icon,
    Confirm,
} from "semantic-ui-react";
import SemanticDatepicker from "react-semantic-ui-datepickers";
import {API_URL} from "../../utils/Common";

import MyLoader from "../sharecomponents/MyLoader";

const initalFormData = Object.freeze({
    cantidad: "0",
});

const Gradosdias = (props) => {
    // -- loader
    const [loader, updateLoader] = useState(false);
    const [formData, updateFormData] = useState(initalFormData);
    const [date, setDate] = useState(new Date());
    const onChangeDate = (event, data) => setDate(data.value);
    // -- filtro fechas
    const [dateFi, setDateFi] = useState(null);
    const onChangeFi = (event, data) => setDateFi(data.value);
    const [dateFf, setDateFf] = useState(null);
    const onChangeFf = (event, data) => setDateFf(data.value);

    // --- filter data
    const [filterData, setFilterData] = useState([]);

    const handleChange = (e) => {
        updateFormData({
            ...formData,
            [e.target.name]: e.target.value.trim(),
        });
    };

    const submmit = () => {
        let fecha = moment(date).format("YYYY-MM-DD");
        updateLoader(true);
        axios.post(API_URL + "/setGrado", {...formData, fecha}).then((r) => {
            updateFormData(initalFormData);
            setDate(null);
            updateLoader(false);
        });
    };

    const filtrar = () => {
        let fi = moment(dateFi).format('YYYY-MM-DD');
        let ff = moment(dateFf).format('YYYY-MM-DD');
        updateLoader(true);
        axios.get(API_URL + '/filtrarGrado', {params: {fi, ff}})
            .then(r => {
                setFilterData([...r.data.filterData]);
                updateLoader(false);
            });
    }

    // -- confirmaciones y acciones para borrar
    const [reg, setReg] = useState(null); // <- Para guardar el registro seleccionado
    const [confDel, setConfDel] = useState(false);
    const actionConfirm = (action, r = null) => {
        switch (action) {
            case 'toborrar':
                setReg({...r});
                setConfDel(true);
                break;

            case 'borrar':
                updateLoader(true);
                axios.post(API_URL + '/delGradoDia', {id: reg.id})
                    .then(r => {
                        updateLoader(false);
                        filtrar();
                    })
                setConfDel(false); // <- Cerrar el modal
                break;

            default:
                setConfDel(false);
                break;
        }
    }

    const confContent = () => (
        <React.Fragment>
            <p style={{padding: '10px', textAlign: 'center', fontSize: '16px'}}>
                ¿Seguro de eliminar el registro seleccionado? <br/>
                {reg &&
                <React.Fragment>
                    Registro seleccionado: <b>Fecha: {reg.fecha}</b> <b>Grados: {reg.cantidad}</b>
                </React.Fragment>
                }
            </p>
        </React.Fragment>
    );

    return (
        <React.Fragment>
            <div className="w-full p-3 right-0">
                <div className="bg-white border rounded shadow-xl">
                    <div className="border-b rounded-t p-3 bg-orange-900">
                        <h5 className="font-bold uppercase text-white">Grados Días</h5>
                        <p className="text-white text-sm">
                            Configuración de los Grados Días
                        </p>
                    </div>
                    <div className="p-5 rounded-b">
                        {/* ---- CONTENIDO --- */}
                        <Form onSubmit={submmit} size="small">
                            <Form.Group inline>
                                <Form.Field>
                                    <label>Fecha:</label>
                                    <SemanticDatepicker
                                        locale="es-ES"
                                        onChange={onChangeDate}
                                        type="basic"
                                        placeholder="Fecha"
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <label>Cantidad:</label>
                                    <Input
                                        type="text"
                                        name="cantidad"
                                        value={formData.cantidad}
                                        onChange={handleChange}
                                        placeholder="Cantidad"
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <Form.Button content="Ingresar" icon="plus"
                                                 style={{backgroundColor: '#7B341E', color: '#fff'}}/>
                                </Form.Field>
                            </Form.Group>
                        </Form>
                        {/** Mostrar datos informados */}
                        <Header as='h3' dividing style={{color: '#7B341E', paddingBottom: '5px'}}>
                            Datos Ingresados
                        </Header>
                        {/** Periodo para buscar */}
                        <Grid columns='six'>
                            <Grid.Column>
                                <SemanticDatepicker
                                    name='fi'
                                    onChange={onChangeFi}/>
                            </Grid.Column>
                            <Grid.Column>
                                <SemanticDatepicker
                                    name='ff'
                                    onChange={onChangeFf}/>
                            </Grid.Column>
                            <Grid.Column>
                                <Button
                                    type='button'
                                    onClick={filtrar}
                                    content='Filtrar'
                                    icon='filter'
                                    style={{backgroundColor: '#7B341E', color: '#fff'}}/>
                            </Grid.Column>
                        </Grid>
                        <Table celled size='small'>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell style={{backgroundColor: '#7B341E', color: '#fff'}}>
                                        Fecha
                                    </Table.HeaderCell>
                                    <Table.HeaderCell style={{backgroundColor: '#7B341E', color: '#fff'}}>
                                        Cantidad de Grados
                                    </Table.HeaderCell>
                                    <Table.HeaderCell width='2'
                                                      style={{backgroundColor: '#7B341E', color: '#fff'}}>
                                        Acciones
                                    </Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {
                                    filterData.map((f, i) => {
                                        return (
                                            <Table.Row key={i}>
                                                <Table.Cell>{f.fecha}</Table.Cell>
                                                <Table.Cell>{f.cantidad}</Table.Cell>
                                                <Table.Cell width='1' style={{textAlign: 'center'}}>
                                                    <Button.Group>
                                                        <Button
                                                            onClick={() => actionConfirm('toborrar', f)}><Icon
                                                            name='trash' size='small'></Icon>Quitar</Button>
                                                    </Button.Group>
                                                </Table.Cell>
                                            </Table.Row>
                                        );
                                    })
                                }
                            </Table.Body>
                        </Table>
                    </div>
                </div>
            </div>
            {loader && <MyLoader/>}

            {/** Confirmación del Borrado */}
            <Confirm
                header='Eliminar Registro'
                open={confDel}
                onConfirm={() => actionConfirm('borrar')}
                onCancel={() => actionConfirm('')}
                content={confContent}/>
        </React.Fragment>
    );
};

export default Gradosdias;
